import { render, staticRenderFns } from "./website-info.vue?vue&type=template&id=144bb866&scoped=true"
import script from "./website-info.vue?vue&type=script&lang=js"
export * from "./website-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144bb866",
  null
  
)

export default component.exports